import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class MGLocationAvailability extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section')?.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  onVariantUpdate = (event) => {
    const next = event.detail.data.html.querySelector('mg-location-availability');
    if (!next || next.dataset.productId !== this.dataset.productId) return;
    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('mg-location-availability')) {
  customElements.define('mg-location-availability', MGLocationAvailability);
}
